var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("代采报表-先货后款")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "form",
                            attrs: { model: _vm.form, "label-width": "85px" }
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "输入搜索：" } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _vm.pgOption
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      filterable: "",
                                                      placeholder: "代采组"
                                                    },
                                                    model: {
                                                      value: _vm.form.pgid,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "pgid",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.pgid"
                                                    }
                                                  },
                                                  _vm._l(_vm.pgOption, function(
                                                    item
                                                  ) {
                                                    return _c("el-option", {
                                                      key: item.key,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.key
                                                      }
                                                    })
                                                  }),
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "商家名称"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.supply_name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "supply_name",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.supply_name"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  filterable: "filterable",
                                                  placeholder: "订单负责人"
                                                },
                                                model: {
                                                  value: _vm.form.order_owner,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "order_owner",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.order_owner"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-option",
                                                  { attrs: { label: "" } },
                                                  [_vm._v("全部")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.owner_option,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.value,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.value
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "代采单" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.woid,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "woid",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.woid"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "款号" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.goods_kh,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "goods_kh",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.goods_kh"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "货号" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.goods_no,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "goods_no",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.goods_no"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "开单来源"
                                                },
                                                model: {
                                                  value: _vm.form.source,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "source",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.source"
                                                }
                                              },
                                              _vm._l(_vm.sources, function(
                                                item
                                              ) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "生成时间" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "daterange",
                                            "value-format": "yyyy-MM-dd",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.create_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "create_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.create_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 2 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.outputAll }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    导出所有数据"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "40px" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          background: "#f3f3f3",
                          height: "50px",
                          "line-height": "30px",
                          padding: "0 25px",
                          display: "flex",
                          "align-items": "center",
                          position: "relative"
                        }
                      },
                      [
                        _vm._v("\n          x\n          "),
                        _c("div", [_vm._v("汇总（全部）")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { position: "absolute", right: "0" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "success" },
                                on: { click: _vm.output }
                              },
                              [_vm._v("\n              导出查询数据")]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.resData.supply,
                          "tooltip-effect": "dark"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_id",
                            label: "商家ID",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reject_data",
                            label: "实际开单",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.kd_num) +
                                          " / " +
                                          _vm._s(scope.row.kd_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3763457374
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reject_out",
                            label: "已回货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.real_stock_in_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.real_stock_in_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            236701548
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "代采欠货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.cg_owe_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.cg_owe_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1401532460
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_settle_status",
                            label: "退换货欠货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.rj_owe_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.rj_owe_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1803637164
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "转抵扣",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.all_ded_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.all_ded_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3681256172
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "已退款",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.all_refund_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.all_refund_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3173674860
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "结束代采",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.cp_num) +
                                          " / " +
                                          _vm._s(scope.row.cp_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3523364574
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reject_out",
                            label: "账单已结算",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.bill_num) +
                                          " / " +
                                          _vm._s(scope.row.bill_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2481789918
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          background: "#f3f3f3",
                          height: "50px",
                          "line-height": "30px",
                          padding: "0 25px",
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [_c("div", [_vm._v("商家订单明细数据")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "800",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark",
                          "cell-class-name": _vm.addBackground,
                          "row-class-name": _vm.tableRowClassName
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "woid",
                            label: "代采订单",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "时间",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pgname",
                            label: "代采组",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "owner_admin_name",
                            label: "订单负责人",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "实际开单",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.kd_num) +
                                          " / " +
                                          _vm._s(scope.row.kd_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3763457374
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reject_out",
                            label: "已回货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.real_stock_in_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.real_stock_in_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            236701548
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "代采欠货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.cg_owe_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.cg_owe_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1401532460
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_settle_status",
                            label: "退换货欠货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.rj_owe_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.rj_owe_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1803637164
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "转抵扣",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.all_ded_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.all_ded_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3681256172
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "已退款",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.all_refund_num) +
                                          " /\n                " +
                                          _vm._s(scope.row.all_refund_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3173674860
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "结束代采",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.cp_num) +
                                          " / " +
                                          _vm._s(scope.row.cp_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3523364574
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reject_out",
                            label: "账单已结算",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.bill_num) +
                                          " / " +
                                          _vm._s(scope.row.bill_amount)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2481789918
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reject_out",
                            label: "操作",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClick(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("查看")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            749024663
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87ce0aca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87ce0aca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supplybill/SupplyXhhkReport.vue
// module id = null
// module chunks = 